import { action, observable } from 'mobx';
import { FormulaFormVM } from '../template/FormulaFormVM';
import { ETriangleRequestDto, ETriangleResponseDto } from 'cd-eft/_codegen_/openapi-generator/eft-set';
import { HydraulicFormulaController } from 'cd-eft/services/eftSetApi';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';

interface IeTriangleForm {
  sideA: string;
  height: string;
}

interface IEntrySelectInterface {
  name: string;
  value: string;
}

export class ETriangleVM extends FormulaFormVM {
  readonly formLabelsForExport;
  readonly resultLabelsForExport;
  constructor(props) {
    super(props); //optional
    this.helpLink =
      'https://usdagcc.sharepoint.com/:b:/r/sites/FPAC-NRCS-EngineeringPlanningAnalysisandDesignSoftwareEPAD/Shared%20Documents/General/NETS-Support%20Documents/Formulas%20Documentation/Help%20Select%20n%20Value.pdf?csf=1&web=1&e=ssYi6q';
    this.formLabelsForExport = {
      sideA: "Side 'a'",
      height: 'Height',
    };
    this.resultLabelsForExport = {
      area: 'Area (sq units)',
    };
  }

  @observable eTriangleResults: ETriangleResponseDto = {
    area: 0,
  };

  @observable savedeTriangleFormData!: IeTriangleForm;
  @observable eTriangleFormControl: number = 0;

  @observable eTriangleFormData: IeTriangleForm = {
    sideA: "0.00",
    height: "0.00",
  };

  @observable entryOptions: IEntrySelectInterface[] = [];

  @observable formValidation = {
    hasError: false,
    sideA: false,
    height: false,
    formErrors: {
      sideA: '',
      height: '',
    },
  };

  @action.bound eTriangleErrorClass(field) {
    const errorMessage = this.formValidation.formErrors[field];
    return errorMessage?.length === 0 ? '' : ' usa-input--error';
  }

  @action.bound handleOnKeyDown(event) {
    ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault();
  }
  @action.bound setFixedValue(name, fixed) {
    const event1 = {
     target: {
     name: name,
     value: this.roundingHelperString(fixed, 2)
     }
     }
    this.handleeTriangleForm(event1, true);
     }
  @action.bound handleeTriangleForm(event, within?:boolean) {
    const { name } = event.target;
    let value = event.target.value;
    if(!within && value.length > 7){
      return
    }
    switch (name) {
      case 'radio-side-a':
        this.eTriangleFormControl = 0;
        this.formValidation.height = false;
        this.formValidation.formErrors.height = '';
        this.formValidation.hasError = false;
        break;
      case 'radio-height':
        this.eTriangleFormControl = 1;
        this.formValidation.sideA = false;
        this.formValidation.formErrors.sideA = '';
        this.formValidation.hasError = false;
        break;
      case 'side-a':
        this.eTriangleFormData.sideA = value;
        break;
      case 'height':
        this.eTriangleFormData.height = value;
        break;
    }
  }

  @action.bound async handleInputOnBlur(name, value) {
    let inputValue: number | string = parseFloat(value);

    if (isNaN(inputValue) || value === '') {
      inputValue = ''; 
    } else {
      inputValue = this.roundingHelperNumber(inputValue, 2);
    }
    const event ={
      target:{
        name: name,
        value: inputValue
      }
    }

    this.handleeTriangleForm(event);

    await this.validateInput(name, inputValue);
    this.calculatedInputBoxValue()
  }

  get sideControl(): boolean {
    return this.eTriangleFormControl === 0;
  }
  get heightControl(): boolean {
    return this.eTriangleFormControl === 1;
  }
  @action.bound async validateInput(name, value) {
    let val;
    if (value !== undefined && value !== '') {
      val = this.roundingHelperNumber(parseFloat(value), 2);
    }
    else {
      val = 0;
    }
    if (value !== undefined && value !== '') {
      this.setFixedValue(name, val);
    }
    switch (name) {
      case 'side-a':
        if (value === '' || val <= 0 || value === undefined) {
          this.formValidation.sideA = true;
          this.formValidation.formErrors.sideA = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined, "Side 'a'");
        } else {
          this.formValidation.sideA = false;
          this.formValidation.formErrors.sideA = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'height':
        if (value === '' || val <= 0 || value === undefined) {
          this.formValidation.height = true;
          this.formValidation.formErrors.height = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined, 'Height');
        } else {
          this.formValidation.height = false;
          this.formValidation.formErrors.height = '';
          this.formValidation.hasError = false;
        }
        break;
    }
  }

  get validateRequiredInputs() {
    if (this.sideControl && !this.formValidation.sideA) { return true }
    else if (this.heightControl && !this.formValidation.height) { return true }
    else { return false; }
  }

  @action async validateReqInput() {
    if (this.sideControl) {
      await this.validateInput('side-a', this.eTriangleFormData.sideA);
    }
    if (this.heightControl) {
      await this.validateInput('height', this.eTriangleFormData.height);
    }
  }

  @action.bound async computeeTriangle() {
    this.disableComputeBtn = true;
    this.disablePrintBtn = true;

    MessageCenter.blockCalls(['Common_26']);
    await this.validateReqInput();
    if (this.validateRequiredInputs) {
      try {
        this.calculatedInputBoxValue();
        const requestPayload: ETriangleRequestDto = {
          sideA: parseFloat(this.eTriangleFormData.sideA),
          height: parseFloat(this.eTriangleFormData.height),
        };
        const response = await HydraulicFormulaController.calculateETriangleUsingPOST(requestPayload);
        const shortCode = response?.data?.errorResponse?.errorCode?.replace(/[123]_[a-zA-Z]+_[a-zA-Z]+_/, '');
        if (response && response.data) {
          if (response.data.validationPass) {
            this.hasResults = true;
            this.disablePrintBtn = false;
            this.eTriangleResults = response.data;
            this.savedeTriangleFormData = { ...this.eTriangleFormData };
          } else if (
            response?.data?.errorResponse?.errorMessage != undefined &&
            response?.data?.errorResponse?.errorType != undefined
          ) {
            MessageCenter.addNotification(
              response?.data?.errorResponse?.errorMessage,
              response?.data?.errorResponse?.errorType,
              shortCode
            );
            this.disablePrintBtn = true;
            this.hasResults = false;
          }
        }
      } catch (error) {
        this.hasResults = false;
        this.disablePrintBtn = true;
        console.error(error);
      }
    } else {
      MessageCenter.resetMessageCenter();
      await MessageCenter.addNotificationFromCode('Common_26');
      this.hasResults = false;
      this.disablePrintBtn = true;
    }
    MessageCenter.unblockCalls();
    this.disableComputeBtn = false;
  }

  @action.bound launchAndExport() {
    // disable print button
    this.disablePrintBtn = true;
    this.exportedInputs = [];
    this.exportedResults = [];

    for (const input in this.savedeTriangleFormData) {
      this.exportedInputs.push({
        label: this.formLabelsForExport[input],
        value: this.savedeTriangleFormData[input],
      });
    }
    for (const result in this.eTriangleResults) {
      if (result !== 'errorResponse' || 'validationPass') {
        const label = this.resultLabelsForExport[result];
        const value = this.eTriangleResults[result];
        if (label && value !== undefined) {
          this.exportedResults.push({
            label: this.resultLabelsForExport[result],
            value: this.eTriangleResults[result],
          });
        }
      }
    }
    this.printFormula();
    this.disablePrintBtn = false;
  }


  @action.bound initializeDefaultValues(): void {
    this.eTriangleFormData = {
      sideA: this.roundingHelperString(this.defaultValues.sideA, 2),
      height: this.roundingHelperString(this.defaultValues.height, 2),
    };
    this.savedeTriangleFormData = { ...this.eTriangleFormData };
  }

  @action.bound calculatedInputBoxValue() {
    if (this.eTriangleFormControl === 0) {
      const value = this.roundingHelperString(((Math.sqrt(3) / 2) * parseFloat(this.eTriangleFormData.sideA)), 2);
      if (value !== 'NaN') {
        this.eTriangleFormData.height = value;
      }
    } else {
      const value = this.roundingHelperString(((2 * parseFloat(this.eTriangleFormData.height)) / Math.sqrt(3)), 2);
      if (value !== 'NaN') {
        this.eTriangleFormData.sideA = value;
      }
    }
  }
}
